import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import Tables from "layouts/tables";
import { useState } from "react";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useGetConcernsQuery } from "slices/wellness/concernSlice";
import { useDeleteConcernMutation } from "slices/wellness/concernSlice";
import { useSelector } from "react-redux";
import { hasActionAccess } from "utility";

function Concerns() {
  const navigate = useNavigate();
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [del] = useDeleteConcernMutation();
  const auth = useSelector((state) => state.auth.auth?.user);

  const { data, refetch } = useGetConcernsQuery({
    page,
    limit,
    search,
  });
  const col = [
    { display: "Title", key: "title", type: "display" },

    {
      display: "Icon",
      key: "icon",
      type: "image",
      style: { width: "100px", height: "100px", borderRadius: "20%" },
    },
    {
      display: "Image",
      key: "image",
      type: "image",
      style: { width: "100px", height: "100px", borderRadius: "20%" },
    },
  ];

  const canEdit = hasActionAccess(auth, "Wellness", "Concerns", "edit");
  const canDelete = hasActionAccess(auth, "Wellness", "Concerns", "delete");

  if (canEdit || canDelete) {
    col.push({
      display: "Actions",
      key: "edit",
      type: "action",
      render: (row, onEdit, handleDelete) => (
        <>
          {canEdit && <Button onClick={() => onEdit(row)}>Edit</Button>}
          {canDelete && (
            <Button onClick={() => handleDelete(row._id)}>Delete</Button>
          )}
        </>
      ),
    });
  }
  const handleSearchChange = (value) => {
    setSearch(value);
    setPage(1);
  };

  const changePage = (newPage, newLimit) => {
    const apiPage = newPage + 1; // MUI is 0-based, API is 1-based
    setPage(apiPage);
    setLimit(newLimit);
  };

  const onEdit = (row) => {
    navigate(`/wellness/concerns/update-concern/${row._id}`);
  };

  const handleAdd = () => {
    navigate("/wellness/concerns/add-concern");
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this concern?")) {
      await del(id).unwrap();
      refetch();
    }
  };

  const canAdd = hasActionAccess(auth, "Wellness", "Concerns", "add");

  return (
    <DashboardLayout>
      <DashboardNavbar />

      {canAdd && (
        <Button onClick={handleAdd} style={{ background: "#fff" }}>
          Add Concerns
        </Button>
      )}

      <Tables
        title={"Concerns"}
        handleSearch={handleSearchChange}
        totalPages={data?.pagination?.totalPages}
        data={data?.data}
        columns={col}
        changePage={changePage}
        onEdit={onEdit}
        handleDelete={handleDelete}
        currentPage={page} // ✅ pass to control current pagination
        rowsPerPage={limit}
      />
      <Footer />
    </DashboardLayout>
  );
}

export default Concerns;
